import type { MutationTree } from "vuex";
import type { Scenario, DataAnalyticsConfig } from "@/types";
import type { DataAnalyticsState } from "@/types/store";
import {
  LOAD_VARIABLES,
  LOAD_VARIABLES_SUCCESS,
  LOAD_VARIABLES_FAILURE,
  UPDATE_MODELIZATION_DATA,
  UPDATE_VARIABLE_TO_MODEL_MODELIZATION_DATA_SUCCESS,
  UPDATE_EXPLICATIVE_VARIABLES_MODELIZATION_DATA_SUCCESS,
  UPDATE_MODELIZATION_RESULT_SUCCESS,
  UPDATE_MODELIZATION_DATA_FAILURE,
  UPDATE_MODELIZATION_RESULT_DATA,
  UPDATE_MODELIZATION_RESULT_DATA_SUCCESS,
  UPDATE_MODELIZATION_RESULT_DATA_ERROR,
  UPDATE_MODELIZATION_RESULT_PROGRESS,
  INIT_EXPLICATIVE_VARIABLES_MODELIZATION_IN_STORE,
  INIT_SCENARIO_IN_STORE,
  INIT_VARIABLE_TO_MODEL_MODELIZATION_IN_STORE,
  INIT_MODELING_RESULT_STORE,
  INIT_PROGRESS_MODELIZATION_TREATMENT_MESSAGE,
  DELETE_EXPLICATIVE_VARIABLE_IN_IN_Store,
  LOAD_SCENARIO_BY_ID,
  LOAD_SCENARIO_BY_ID_SUCCESS,
  LOAD_SCENARIO_BY_ID_FAILURE,
  ADD_SCENARIO,
  ADD_SCENARIO_SUCCESS,
  ADD_SCENARIO_FAILURE,
  UPDATE_SCENARIO,
  UPDATE_SCENARIO_SUCCESS,
  UPDATE_SCENARIO_FAILURE,
  LOAD__DATA_ANALYTICS_CONFIG,
  LOAD__DATA_ANALYTICS_CONFIG_SUCCESS,
  LOAD__DATA_ANALYTICS_CONFIG_FAILURE,
  ADD_DATA_ANALYTICS_CONFIG,
  ADD_DATA_ANALYTICS_CONFIG_SUCCESS,
  ADD_DATA_ANALYTICS_CONFIG_FAILURE,
  UPDATE_DATA_ANALYTICS_CONFIG,
  UPDATE_DATA_ANALYTICS_CONFIG_SUCCESS,
  UPDATE_DATA_ANALYTICS_CONFIG_FAILURE,
  DELETE_DATA_ANALYTICS_CONFIG,
  DELETE_DATA_ANALYTICS_CONFIG_SUCCESS,
  DELETE_DATA_ANALYTICS_CONFIG_FAILURE,
} from "./labels";

export const mutations: MutationTree<DataAnalyticsState> = {
  // VARIABLES
  [LOAD_VARIABLES](state: DataAnalyticsState) {
    state.variables = { ...state.variables, loading: true, error: null };
  },
  [LOAD_VARIABLES_SUCCESS](state: DataAnalyticsState, data: any) {
    state.variables = {
      data: data.variables,
      count: data.count,
      loading: false,
      error: null,
    };
  },

  [LOAD_VARIABLES_FAILURE](state: DataAnalyticsState, error: string) {
    state.variables = { ...state.variables, loading: false, error: error };
  },
  [UPDATE_MODELIZATION_DATA](state: DataAnalyticsState) {
    state.modelization = { ...state.modelization, loading: true, error: null };
  },
  [UPDATE_MODELIZATION_RESULT_DATA](state: DataAnalyticsState) {
    state.modelization = { ...state.modelization, loading: true, error: null };
  },
  [UPDATE_MODELIZATION_RESULT_DATA_SUCCESS](
    state: DataAnalyticsState,
    data: any,
  ) {
    state.modelization.progress = null;
    state.modelization.loading = false;
    state.modelization.data = {
      ...(state.modelization.data = {
        ...state.modelization.data,
        modelingResultData: data,
      }),
    };
  },
  [UPDATE_MODELIZATION_RESULT_PROGRESS](
    state: DataAnalyticsState,
    message: string,
  ) {
    state.modelization = {
      ...state.modelization,
      loading: true,
      progress: message,
    };
  },
  [UPDATE_MODELIZATION_RESULT_DATA_ERROR](
    state: DataAnalyticsState,
    error: string,
  ) {
    state.modelization = {
      ...state.modelization,
      loading: false,
      error: error,
    };
  },
  [UPDATE_VARIABLE_TO_MODEL_MODELIZATION_DATA_SUCCESS](
    state: DataAnalyticsState,
    variable: any,
  ) {
    state.modelization.data = {
      ...state.modelization.data,
      variableToModel: variable,
    };
    state.modelization.loading = false;
  },
  [UPDATE_EXPLICATIVE_VARIABLES_MODELIZATION_DATA_SUCCESS](
    state: DataAnalyticsState,
    variable: any,
  ) {
    if (state.modelization.data.variablesExplicatives)
      state.modelization.data = {
        ...state.modelization.data,
        variablesExplicatives: [
          ...state.modelization.data.variablesExplicatives,
          variable,
        ],
      };
    else {
      state.modelization.data = {
        ...state.modelization.data,
        variablesExplicatives: [variable],
      };
    }
    state.modelization.loading = false;
  },
  [UPDATE_MODELIZATION_RESULT_SUCCESS](state: DataAnalyticsState, result: any) {
    state.modelization.progress = null;
    state.modelization.data = {
      ...state.modelization.data,
      ModelingResult: result,
    };
    state.modelization.loading = false;
  },

  [UPDATE_MODELIZATION_DATA_FAILURE](state: DataAnalyticsState, error: string) {
    state.modelization = {
      ...state.modelization,
      loading: false,
      error: error,
    };
  },
  [INIT_EXPLICATIVE_VARIABLES_MODELIZATION_IN_STORE](
    state: DataAnalyticsState,
  ) {
    if (state.modelization.data.variablesExplicatives)
      state.modelization.data = {
        ...state.modelization.data,
        variablesExplicatives: [],
      };
  },
  [INIT_SCENARIO_IN_STORE](state: DataAnalyticsState) {
    if (state.newScenario.data) {
      state.newScenario = {
        data: [],
        loading: false,
        error: null,
      };
    }
  },
  [INIT_PROGRESS_MODELIZATION_TREATMENT_MESSAGE](state: DataAnalyticsState) {
    if (state.modelization.progress) {
      state.modelization.progress = null;
    }
    if (state.modelization.error) {
      state.modelization.error = null;
    }
  },
  [INIT_VARIABLE_TO_MODEL_MODELIZATION_IN_STORE](state: DataAnalyticsState) {
    if (state.modelization.data.variableToModel)
      delete state.modelization.data.variableToModel;
  },
  [INIT_MODELING_RESULT_STORE](state: DataAnalyticsState) {
    if (state.modelization.data.ModelingResult)
      delete state.modelization.data.ModelingResult;
    if (state.modelization.data.modelingResultData)
      delete state.modelization.data.modelingResultData;
  },
  [DELETE_EXPLICATIVE_VARIABLE_IN_IN_Store](
    state: DataAnalyticsState,
    variable: any,
  ) {
    if (state.modelization.data.variablesExplicatives)
      state.modelization.data = {
        ...state.modelization.data,
        variablesExplicatives:
          state.modelization.data.variablesExplicatives.filter(
            (expVar: any) =>
              !(
                expVar.id === variable.id &&
                expVar.aggregation.id === variable.aggregation.id
              ),
          ),
      };
  },
  // LOAD_SCENARIO
  [LOAD_SCENARIO_BY_ID](state: DataAnalyticsState) {
    state.newScenario = { ...state.newScenario, loading: true, error: null };
  },
  [LOAD_SCENARIO_BY_ID_SUCCESS](state: DataAnalyticsState, scenario: Scenario) {
    state.newScenario = {
      data: scenario,
      loading: false,
      error: null,
    };
  },
  [LOAD_SCENARIO_BY_ID_FAILURE](state: DataAnalyticsState, error: string) {
    state.newScenario = { ...state.newScenario, loading: false, error: error };
  },
  // ADD_SCENARIO
  [ADD_SCENARIO](state: DataAnalyticsState) {
    state.newScenario = { ...state.newScenario, loading: true, error: null };
  },
  [ADD_SCENARIO_SUCCESS](state: DataAnalyticsState, scenario: Scenario) {
    state.newScenario = {
      data: scenario,
      loading: false,
      error: null,
    };
  },
  [ADD_SCENARIO_FAILURE](state: DataAnalyticsState, error: string) {
    state.newScenario = {
      ...state.newScenario,
      loading: false,
      error: error,
    };
  },
  [UPDATE_SCENARIO](state: DataAnalyticsState) {
    state.newScenario = { ...state.newScenario, loading: true, error: null };
  },
  [UPDATE_SCENARIO_SUCCESS](state: DataAnalyticsState, scenario: Scenario) {
    state.newScenario = {
      data: { ...scenario, updated: true },
      loading: false,
      error: null,
    };
  },
  [UPDATE_SCENARIO_FAILURE](state: DataAnalyticsState, error: string) {
    state.newScenario = {
      ...state.newScenario,
      loading: false,
      error: error,
    };
  },
  [LOAD__DATA_ANALYTICS_CONFIG](state: DataAnalyticsState) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: true,
      error: null,
    };
  },
  [LOAD__DATA_ANALYTICS_CONFIG_SUCCESS](
    state: DataAnalyticsState,
    dataAnalyticsConfigs: DataAnalyticsConfig[],
  ) {
    state.dataAnalyticsConfig = {
      data: dataAnalyticsConfigs,
      loading: false,
      error: null,
    };
  },
  [LOAD__DATA_ANALYTICS_CONFIG_FAILURE](
    state: DataAnalyticsState,
    error: string,
  ) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: false,
      error: error,
    };
  },
  [ADD_DATA_ANALYTICS_CONFIG](state: DataAnalyticsState) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: true,
      error: null,
    };
  },
  [ADD_DATA_ANALYTICS_CONFIG_SUCCESS](
    state: DataAnalyticsState,
    addedConfig: DataAnalyticsConfig,
  ) {
    state.dataAnalyticsConfig = {
      data: [...state.dataAnalyticsConfig.data, addedConfig],
      loading: false,
      error: null,
    };
  },
  [ADD_DATA_ANALYTICS_CONFIG_FAILURE](
    state: DataAnalyticsState,
    error: string,
  ) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: false,
      error: error,
    };
  },
  [UPDATE_DATA_ANALYTICS_CONFIG](state: DataAnalyticsState) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: true,
      error: null,
    };
  },
  [UPDATE_DATA_ANALYTICS_CONFIG_SUCCESS](
    state: DataAnalyticsState,
    updatedConfig: DataAnalyticsConfig,
  ) {
    state.dataAnalyticsConfig.data[
      state.dataAnalyticsConfig.data.findIndex(
        (conf: DataAnalyticsConfig) => conf.id === updatedConfig.id,
      )
    ] = updatedConfig;
    state.dataAnalyticsConfig.loading = false;
    state.dataAnalyticsConfig.error = null;
  },
  [UPDATE_DATA_ANALYTICS_CONFIG_FAILURE](
    state: DataAnalyticsState,
    error: string,
  ) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: false,
      error: error,
    };
  },
  [DELETE_DATA_ANALYTICS_CONFIG](state: DataAnalyticsState) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: true,
      error: null,
    };
  },
  [DELETE_DATA_ANALYTICS_CONFIG_SUCCESS](
    state: DataAnalyticsState,
    dataAnalyticId: string,
  ) {
    state.dataAnalyticsConfig = {
      data: state.dataAnalyticsConfig.data.filter(
        (conf: DataAnalyticsConfig) => conf.id !== dataAnalyticId,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_DATA_ANALYTICS_CONFIG_FAILURE](
    state: DataAnalyticsState,
    error: string,
  ) {
    state.dataAnalyticsConfig = {
      ...state.dataAnalyticsConfig,
      loading: false,
      error: error,
    };
  },
};
